"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreTagsGetAsyncSlice = void 0;
const name_1 = require("./name.js");
const xuder_1 = require("@sonar-software/xuder");
const _api_1 = require("../../api/index.js");
const actions_1 = require("./_idMap/actions.js");
exports.coreTagsGetAsyncSlice = (0, xuder_1.createGetAsyncSlice)({
    httpSagaOptions: {
        successDataActionCreators: [(response) => (0, actions_1.updateTagReferences)(response)]
    },
    name: name_1.CoreTagsName,
    receive: true,
    request: false,
    requestHandler: () => (0, _api_1.getTags)().then((response) => (Object.assign(Object.assign({}, response), { data: response.data ? response.data.sort((a, b) => a.name.localeCompare(b.name)) : undefined }))),
    retainDataOnRequest: true
});
//# sourceMappingURL=get.js.map